import { render, staticRenderFns } from "./downloadSection.vue?vue&type=template&id=6059151e&scoped=true&"
import script from "./downloadSection.vue?vue&type=script&lang=js&"
export * from "./downloadSection.vue?vue&type=script&lang=js&"
import style0 from "./downloadSection.vue?vue&type=style&index=0&id=6059151e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6059151e",
  null
  
)

export default component.exports